export default __webpack_public_path__ + "static/media/create-reminder.87fd0109.webp";